import { types } from './types'

interface AuthProtocol {
  payload: any
  type: string
}
interface CourseModuleStateProps {
  formData: object
  openAttachments: boolean
  openCommentQuestion: boolean
  openPerson: boolean
  openTag: boolean
  openVideo: boolean
  openWeeks: boolean
  openImages: boolean
  openMarks: boolean
  openStylesheets: boolean
}

const INITIAL_STATE: CourseModuleStateProps = {
  formData: {},
  openVideo: false,
  openTag: false,
  openPerson: false,
  openAttachments: false,
  openCommentQuestion: false,
  openWeeks: false,
  openImages: false,
  openMarks: false,
  openStylesheets: false,
}

export const courseReducer = (
  state = INITIAL_STATE,
  { type, payload }: AuthProtocol,
) => {
  if (type === types.UPDATE_FORMDATA) {
    return { ...state, formData: payload }
  }
  if (type === types.OPEN_VIDEO) {
    return { ...state, openVideo: !state.openVideo }
  }
  if (type === types.OPEN_TAG) {
    return { ...state, openTag: !state.openTag }
  }
  if (type === types.OPEN_PERSON) {
    return { ...state, openPerson: !state.openPerson }
  }
  if (type === types.OPEN_ATTACHMENTS) {
    return { ...state, openAttachments: !state.openAttachments }
  }
  if (type === types.OPEN_COMMENTQUESTION) {
    return { ...state, openCommentQuestion: !state.openCommentQuestion }
  }
  if (type === types.OPEN_WEEKS) {
    return { ...state, openWeeks: !state.openWeeks }
  }
  if (type === types.OPEN_IMAGES) {
    return { ...state, openImages: !state.openImages }
  }
  if (type === types.OPEN_MARKS) {
    return { ...state, openMarks: !state.openMarks }
  }
  if (type === types.OPEN_STYLESHEET) {
    return { ...state, openStylesheets: !state.openStylesheets }
  }
  return state
}
